import type { Helpers } from "./endpoints-shared";
import type { In, Out } from "./operations";

export function workspaceEndpoints({ get, post, put }: Helpers) {
  return {
    dashboard: (signal?: AbortSignal) => get<Out<"core_read_dashboard">>("/workspace/dashboard", { signal }),
    saveDashboard: (body: In<"core_save_dashboard">) => put<Out<"core_save_dashboard">>("/workspace/dashboard", body),
    heartbeat: () => post<Out<"core_heartbeat">>("/workspace/presence"),
    presence: (signal?: AbortSignal) => get<Out<"core_read_presence">>("/workspace/presence", { signal }),
    inbox: (signal?: AbortSignal) => get<Out<"core_chat_inbox">>("/workspace/chat", { signal }),
    conversation: (id: string, signal?: AbortSignal) => get<Out<"core_conversation">>(`/workspace/chat/${id}`, { signal }),
    send: (id: string, body: In<"core_send_message">) => post<Out<"core_send_message">>(`/workspace/chat/${id}`, body),
    read: (id: string, ids: string[]) => post<Out<"core_read_messages">>(`/workspace/chat/${id}/read`, { ids }),
    release: (signal?: AbortSignal) => get<Out<"core_workspace_release">>("/workspace/release", { signal }),
  };
}
